import React from "react";
import { twMerge } from "tailwind-merge";
import { theme } from "./index";

interface ThreatIntelProps {
  className?: string;
}

export const ThreatIntel: React.FC<ThreatIntelProps> = ({ className }) => (
  <svg
    width="19"
    height="19"
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={twMerge(
      theme,
      className,
    )}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 2.56386C0 1.4064 0.937681 0.466888 2.09586 0.466888H14.9891C16.1472 0.466888 17.0849 1.4064 17.0849 2.56386V8.69348C17.0849 9.13892 16.7238 9.50001 16.2783 9.50001C15.833 9.50001 15.4718 9.13892 15.4718 8.69348V5.14476H1.61306V14.1779C1.61306 14.4458 1.82987 14.6618 2.09586 14.6618H5.63896C6.08439 14.6618 6.44549 15.0229 6.44549 15.4683C6.44549 15.9138 6.08439 16.2749 5.63896 16.2749H2.09586C0.937681 16.2749 0 15.3353 0 14.1779V2.56386ZM7.90725 16.4265L11.6985 9.58951C11.9096 9.11738 12.4051 8.7954 12.9236 8.7954C13.443 8.7954 13.9391 9.11855 14.1497 9.592L17.8786 16.4324C18.1059 16.8526 18.1072 17.3799 17.8822 17.8011C17.6538 18.2421 17.1757 18.5333 16.6788 18.5331H9.10384C8.60695 18.5333 8.12874 18.2421 7.9004 17.8011C7.67541 17.3799 7.67673 16.8526 7.90403 16.4324L7.90725 16.4265ZM12.8976 11.4568C13.3431 11.4568 13.7042 11.8179 13.7042 12.2633V13.8764C13.7042 14.3218 13.3431 14.683 12.8976 14.683C12.4523 14.683 12.0912 14.3218 12.0912 13.8764V12.2633C12.0912 11.8179 12.4523 11.4568 12.8976 11.4568ZM12.8916 17.4041C12.9033 17.4041 12.915 17.4039 12.9267 17.4035C13.4449 17.3848 13.8593 16.9588 13.8593 16.4362C13.8593 15.9015 13.4258 15.4682 12.8913 15.4682C12.8795 15.4682 12.8677 15.4685 12.8561 15.469C12.3379 15.4876 11.9236 15.9135 11.9236 16.4363C11.9236 16.9708 12.3569 17.4041 12.8916 17.4041Z"
    />
  </svg>
);
